import { Component, Input } from '@angular/core';
import { CurrentTenantService } from '@suvo-bi-users';
import { IIconColumnsTileInstance } from '../../../../interfaces/tiles/definitions/icon-columns-tile-definition.interface';
import { resolveSiteAssetCssValue } from '../../../../utils/resolve-site-asset-url.util';

@Component({
  standalone: false,
  selector: 'suvi-bi-icon-columns-tile',
  templateUrl: './icon-columns-tile.component.html',
  styleUrls: ['./icon-columns-tile.component.scss'],
})
export class IconColumnsTileComponent {
  @Input() tileInstance: IIconColumnsTileInstance;

  constructor(private readonly tenantService: CurrentTenantService) {}

  get backgroundStyle(): string {
    return resolveSiteAssetCssValue(
      this.tileInstance?.background ?? '',
      this.tenantService.currentTenantData?.primaryWebUrl ?? '',
    );
  }
}
